import { gql } from "@apollo/client";

export const OFFERS_HISTORY_QUERY = gql`
  query offersHistory($documentId: Int!) {
    offersHistory(documentId: $documentId) {
      offerDate
      insurerName
      userName
      period
      insuranceAmount
      insuranceAmountWithDirectCompensation
      insurerErrors
    }
  }
`;

export const HAS_OFFERS_HISTORY_QUERY = gql`
  query hasOffersHistory($documentId: Int!) {
    hasOffersHistory(documentId: $documentId)
  }
`;
